import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    FormControl,
    FormHelperText,
    FormLabel,
    Input,
    Option,
    Select,
    Stack,
    Typography,
} from "@mui/joy";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Sheet from "@mui/joy/Sheet";
import Grid from "@mui/joy/Grid";
import Tooltip from "@mui/joy/Tooltip";
import IconButton from "@mui/joy/IconButton";
import { useParams } from "react-router-dom";
//import { BASE_URL_FRONTEND } from "../../config/Url-config";
import { SlUserFollowing, SlUserUnfollow } from "react-icons/sl";
import ChangePassword from "./UserChangePassword";
import SuccessPopUp from "../Utility/SuccessPopUp";
import SpinnerBox from "../Utility/SpinnerBox";
import ErrorPopUp from "../Utility/ErrorPopUp";
import DeactivateAccount from "./UserDeactivation";
import * as apiUtility from "../../config/APIUtils";
import { useUser } from "../../config/UserContext";
import HelpIconInfo from "../Utility/HelpIconBox";
import { useNavigate } from "react-router-dom";


const initialState = {
    firstName: "",
    middleName: "",
    lastName: "",
    userName: "",
    dob: "",
    gender: "",
    email: "",
    number: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    city: "",
    state: "",
    postalCode: "",
};

const BASE_URL_USER = "user/getUser/";
const BASE_URL_USER_UPDATE = "user/update/";


const requiredFields = [
    "firstName",
    "lastName",
    "userName",
    "email",
    "dob",
    "gender",
    "number",
    "addressLine1",
    "city",
    "country",
    "state",
    "postalCode",
];


const STATES = {
    Canada: ["Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon Territory"],
    USA: ["California", "Texas", "New York", "Florida", "Other"],
};

const GENDERS = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "U", label: "Other/Prefer not to disclose" },
];

const firstNameRegex = /^[A-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<, -]*$/i;
const usernameRegex = /^[a-zA-Z0-9]+$/;
const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const canadaPostalRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;


const isValidAge = (dateStr) => {
    if (!dateStr) return false;

    const dob = new Date(dateStr);
    const today = new Date();

    const age =
        today.getFullYear() -
        dob.getFullYear() -
        (today < new Date(today.getFullYear(), dob.getMonth(), dob.getDate())
            ? 1
            : 0);

    return dob.getFullYear() > 1900 && age >= 10;
};



export default function UserProfileUpdated(props) {
    
    const [formData, setFormData] = useState(initialState);
    const [initialData, setInitialData] = useState(initialState);

    const [errors, setErrors] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);

    const [showDeactivation, setShowDeactivation] = useState(false);
    const [verifiedStatus, setVerifiedStatus] = useState(true);
    const [activeStatus, setActiveStatus] = useState(true);

    const [showSuccess, setShowSuccess] = useState(false);
    const [successMsg, setsuccessMsg] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [showPassword, setshowPassword] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const { screenDetails: { fieldSize, stackOrientation } } = useUser();
    const { id: urlParamId } = useParams();
    const params = (props?.userId !== undefined) ? props.userId : urlParamId;
    
    const navigate = useNavigate();
    const home = useParams().home;
    const currentHome = home || '';
    const userType = sessionStorage.getItem("userType");
    const userId_session = sessionStorage.getItem("userId");

    useEffect(() => {
        fetchUserProfile();
    }, [params]);

    useEffect(() => {
        const hasErrors = Object.values(errors).some(Boolean);
        const missingRequired = requiredFields.some((field) => !formData[field]);

        setIsFormValid(!hasErrors && !missingRequired);

    }, [errors, formData]);

    useEffect(() => {
        setIsDirty(JSON.stringify(formData) !== JSON.stringify(initialData));

    }, [formData, initialData]);

    const fetchUserProfile = () => {
        if (userType !== "admin" && userId_session !== params) {
            return (currentHome ? navigate(`/${currentHome}/login`) : navigate(`/login`));
        }
        let apiParams = apiUtility.apiInputRequest;
        apiParams.endPoint = BASE_URL_USER + params;
        apiUtility.fetchAPIDataGET(apiParams)
            .then((res) => {
                let response = res.data.data;
                if (response !== undefined) {

                    let phoneNumber = String(response.number).replace(/\D/g, "");
                    if (!phoneNumber.startsWith("1")) {
                        phoneNumber = "+1" + phoneNumber;
                    } else if (phoneNumber.startsWith("1")) {
                        phoneNumber = "+" + phoneNumber;
                    }

                    response.number = phoneNumber;

                    setFormData(response);
                    setInitialData(response);
                    setIsInitialized(true);
                    setErrors({});

                    setVerifiedStatus(response.verified);
                    setActiveStatus(response.active !== undefined ? response.active : true);

                } else {
                    setErrorMsg("Internal server error. Please try again later.");
                    setFormData(initialState);
                    setInitialData(initialState);
                }
            })
            .catch((err) => {
                setErrorMsg("Internal server error. Please try again later.");
                setShowErrorMsg(true);
            });
    }



    const handleChange = (name, value) => {
        setFormData((prev) => {
            const updated = { ...prev, [name]: value };

            if (isInitialized) {
                setErrors((err) => ({
                    ...err,
                    [name]: validateField(name, value, updated),
                }));
            }

            return updated;
        });
    };

    const validateField = (name, value, data = formData) => {
        switch (name) {
            case "firstName":
                if (!value) return "First name is required";
                if (!firstNameRegex.test(value)) return "Invalid characters in first name";
                return "";

            case "lastName":
                if (!value) return "Last name is required";
                return "";

            case "userName":
                if (!value) return "Username is required";
                if (!usernameRegex.test(value)) return "Alphanumeric only";
                return "";

            case "email":
                if (!value) return "Email is required";
                if (!emailRegex.test(value)) return "Invalid email format";
                return "";

            case "dob":
                if (!isValidAge(value))
                    return "Age must be ≥ 10 years and year > 1900";
                return "";

            case "gender":
                if (!value) return "Gender is required";
                return "";

            case "number":
                if (!value) return "Contact number is required";
                return "";

            case "addressLine1":
                if (!value) return "Address Line 1 is required";
                return "";

            case "city":
                if (!value) return "City is required";
                return "";

            case "country":
                if (!value) return "Country is required";
                return "";

            case "state":
                if (!value) return "State is required";
                return "";

            case "postalCode":
                if (!value) return "Postal code is required";
                if (
                    data.country === "Canada" &&
                    !canadaPostalRegex.test(value)
                )
                    return "Invalid postal code";
                return "";

            default:
                return "";
        }
    };


    const validate = () => {
        const newErrors = {};

        Object.keys(formData).forEach((key) => {
            const error = validateField(key, formData[key]);
            if (error) newErrors[key] = error;
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async () => {
        setShowSpinner(true);
        try {
            if (!validate()) return;
            formData.firstName = formData.firstName.trim();
            formData.lastName = formData.lastName.trim();
            formData.middleName = formData.middleName.trim();
            formData.userName = formData.userName.trim();

            if (formData.firstName === "" || formData.firstName.length <= 0) {
                formData.firstName = "-";
            }
            if (formData.lastName === "" || formData.lastName.length <= 0) {
                formData.lastName = "-";
            }
            if (formData.middleName === "" || formData.middleName.length <= 0) {
                formData.middleName = "-";
            }

            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_USER_UPDATE + params;
            apiRequest.data = formData;
            const res = await apiUtility.updateAsyncAPIDataPUT(apiRequest);
            const resJson = res.data.data;


            if (resJson === undefined) {
                setErrorMsg("Something went wrong! Please try again.");
                setShowErrorMsg(true);
            } else if (resJson === 'Username is already taken!' || resJson === 'Email is already used by another user!' || resJson === 'User details Already in use!') {
                setErrorMsg(resJson);
                setShowErrorMsg(true);
            } else {
                setShowSuccess(true);
                setsuccessMsg("Record updated successfully!");
            }
        } catch (error) {
            setErrorMsg("Error while processing request");
            setShowErrorMsg(true);
        }

        setShowSpinner(false);
    };

    const handleUpdateCallback = (result) => {
        setshowPassword(false);
        setsuccessMsg(result);
        setShowSuccess(true);
    };

    const handleDeactivationCallback = (result) => {
        setShowDeactivation(false);
        if (result === "Account deactivated successfully!") {
            if (userType !== undefined && userType !== "admin") {
                setsuccessMsg(result + " Logging you out in 5 Seconds...");
                setShowSuccess(true);
                setTimeout(() => {
                    apiUtility.logOut();
                    return navigate(`/${currentHome}/`);
                }, 5000);
            } else {
                setsuccessMsg(result);
                setShowSuccess(true);
                setActiveStatus(false);
                setVerifiedStatus(false);
            }
        }
    };

    const activateAccountForUser = () => {
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "login/activate";
        apiRequest.data = { login_id: formData.userName };
        apiUtility
            .sendAPIDataPOST(apiRequest)
            .then((res) => {
                if (res.data.msg !== "Cannot fetch user info!") {
                    setshowPassword(false);
                    setsuccessMsg(res.data.msg);
                    setShowSuccess(true);
                    setActiveStatus(true);
                } else {
                    setErrorMsg(res.data.msg);
                    setShowErrorMsg(true);
                }
            })
            .catch((err) => {
                setErrorMsg("Something went wrong!");
                setShowErrorMsg(true);
            });
    };

    return (
        <Box sx={{ maxWidth: 1300, mx: "auto", p: 2 }}>
            <Stack spacing={3}>
                <Sheet
                    variant="soft"
                    color="primary"
                    sx={{
                        p: 2,
                        borderRadius: "md",
                        display: "flex"
                    }}
                >
                    <Stack direction="column" sx={{ width: "100%" }}>
                        <Stack direction={stackOrientation} sx={{ width: "100%", mb:1 }} justifyContent="space-between" alignItems="center">
                        <Typography level="h3" sx={{ color: "#006699", fontWeight: 350 }}>
                            Welcome {formData.firstName || "User"}
                        </Typography>

                        {(userType !== undefined && userType === "admin") && (
                            verifiedStatus === true || verifiedStatus === "true" ? (
                                <Tooltip variant="outlined" color="success" sx={{ p: 1 }} title="Verified & Active">
                                    <IconButton>
                                        <SlUserFollowing style={{ fontSize: "1.5pc", color: "#016799" }} />
                                    </IconButton>
                                </Tooltip>
                            ) : (activeStatus === false || activeStatus === "false") &&
                                (verifiedStatus === false || verifiedStatus === "false") ? (
                                <Tooltip variant="outlined" color="danger" title="Either not verified or Active">
                                    <IconButton>
                                        <SlUserUnfollow style={{ fontSize: "1.5pc", color: "red" }} />
                                    </IconButton>
                                </Tooltip>
                            ) : (
                                <Tooltip variant="outlined" color="danger" title="Unverified and Inactive">
                                    <IconButton>
                                        <SlUserUnfollow style={{ fontSize: "1.5pc", color: "#0f6fc5" }} />
                                    </IconButton>
                                </Tooltip>
                            )
                        )}
                        <Typography level="h4" sx={{ color: "#006699", fontWeight: 350 }}>User ID - {params}</Typography>
                        </Stack>
                        <HelpIconInfo link={"https://carepassportcareltc.atlassian.net/wiki/external/MDg3NzI5ZDFjMzA5NDc3MjljMDg1ZjAxZThkNmY4YmI"} msg={"Manage your user account info"} />
                        {/* <Stack direction="row" >
                            <IconButton size="xs" variant="plain" aria-label="Help icon"
                            sx={{
                                color: "#016799",
                                mt: 1,
                                fontSize: "15px",
                                fontWeight: 400,
                                "--IconButton-size": "15px",
                                '&:hover': {
                                    bgcolor: 'primary.plainHoverBg',
                                    color: 'primary.plainColor',
                                    variant: 'primary.soft',
                                    transform: 'scale(1.05)',
                                    transition: 'transform 0.5s',
                                },
                            }}
                            onClick={() => window.open('https://carepassportcareltc.atlassian.net/wiki/external/MDg3NzI5ZDFjMzA5NDc3MjljMDg1ZjAxZThkNmY4YmI', '_blank')}>
                               <ContactSupportOutlinedIcon sx={{fontSize:"17px"}} />&nbsp;Manage your user account info
                            </IconButton>
                        </Stack> */}
                    </Stack>
                </Sheet>

                <Card>
                    <CardContent>
                        <Typography level="h5" sx={{ color: "#006699", fontWeight: 300 }}>Personal Details</Typography>
                        <Divider sx={{ my: 2 }} />
                        {/* <Grid container spacing={1}> */}

                            <Grid container spacing={3}>
                                <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.firstName}>
                                        <FormLabel>First Name</FormLabel>
                                        <Input
                                            placeholder="First Name"
                                            value={formData.firstName}
                                            size={fieldSize}
                                            onChange={(e) =>
                                                handleChange("firstName", e.target.value)
                                            }
                                        />
                                        <FormHelperText>{errors.firstName}</FormHelperText>
                                    </FormControl>
                                </Grid>

                                <Grid xs={12} sm={4}>
                                    <FormControl>
                                        <FormLabel>Middle Name</FormLabel>
                                        <Input
                                            placeholder="Middle Name"
                                            value={formData.middleName}
                                            size={fieldSize}
                                            onChange={(e) =>
                                                handleChange("middleName", e.target.value)
                                            }
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.lastName}>
                                        <FormLabel>Last Name</FormLabel>
                                        <Input
                                            placeholder="Last Name"
                                            value={formData.lastName}
                                            size={fieldSize}
                                            onChange={(e) =>
                                                handleChange("lastName", e.target.value)
                                            }
                                        />
                                        <FormHelperText>{errors.lastName}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                                <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.userName}>
                                        <FormLabel>Username</FormLabel>
                                        <Input
                                            placeholder="User Name"
                                            value={formData.userName}
                                            size={fieldSize}
                                            onChange={(e) =>
                                                handleChange("userName", e.target.value)
                                            }
                                        />
                                        <FormHelperText>{errors.userName}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.email}>
                                        <FormLabel>Email</FormLabel>
                                        <Input
                                            placeholder="Email address"
                                            value={formData.email}
                                            size={fieldSize}
                                            onChange={(e) =>
                                                handleChange("email", e.target.value)
                                            }
                                        />
                                        <FormHelperText>{errors.email}</FormHelperText>
                                    </FormControl>
                                </Grid>

                                <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.dob}>
                                        <FormLabel>Date of Birth</FormLabel>
                                        <Input
                                            type="date"
                                            value={formData.dob}
                                            size={fieldSize}
                                            onChange={(e) => handleChange("dob", e.target.value)}
                                            slotProps={{
                                                input: {
                                                    min: "1901-01-01",
                                                    max: new Date(
                                                        new Date().setFullYear(new Date().getFullYear() - 10)
                                                    )
                                                        .toISOString()
                                                        .split("T")[0],
                                                },
                                            }}
                                        />
                                        <FormHelperText>{errors.dob}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.gender}>
                                        <FormLabel>Gender</FormLabel>
                                        <Select
                                            value={formData.gender ?? null}
                                            size={fieldSize}
                                            onChange={(_, val) => handleChange("gender", val)}
                                        >
                                            {GENDERS.map((g) => (
                                                <Option key={g.value} value={g.value}>
                                                    {g.label}
                                                </Option>
                                            ))}
                                        </Select>
                                        <FormHelperText>{errors.gender}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid xs={12} sm={4}>
                                    <FormControl error={!!errors.number}>
                                        <FormLabel>Contact Number</FormLabel>
                                        <PhoneInput
                                            international
                                            defaultCountry="CA"
                                            value={formData.number}
                                            onChange={(val) =>
                                                handleChange("number", val)
                                            }
                                        />
                                        <FormHelperText>{errors.number}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        {/* </Grid> */}
                    </CardContent>
                </Card>

                <Card>
                    <CardContent>
                        <Typography level="h5" sx={{ color: "#006699", fontWeight: 300 }}>Address Details</Typography>
                        <Divider sx={{ my: 2 }} />
                        <Grid container spacing={3}>
                            <Grid xs={12} sm={12}>
                                <FormControl error={!!errors.addressLine1}>
                                    <FormLabel>Address Line 1</FormLabel>
                                    <Input
                                        placeholder="Address Line 1"
                                        value={formData.addressLine1}
                                        size={fieldSize}
                                        onChange={(e) =>
                                            handleChange("addressLine1", e.target.value)
                                        }
                                    />
                                    <FormHelperText>{errors.addressLine1}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid xs={12} sm={12}>
                                <FormControl>
                                    <FormLabel>Address Line 2</FormLabel>
                                    <Input
                                        placeholder="Address Line 2"
                                        value={formData.addressLine2}
                                        size={fieldSize}
                                        onChange={(e) =>
                                            handleChange("addressLine2", e.target.value)
                                        }
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid xs={12} sm={6}>
                                <FormControl error={!!errors.city}>
                                    <FormLabel>City</FormLabel>
                                    <Input
                                        placeholder="City"
                                        value={formData.city}
                                        size={fieldSize}
                                        onChange={(e) =>
                                            handleChange("city", e.target.value)
                                        }
                                    />
                                    <FormHelperText>{errors.city}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={6}>
                                <FormControl error={!!errors.postalCode}>
                                    <FormLabel>Postal Code</FormLabel>
                                    <Input
                                        placeholder="LNL NLN"
                                        value={formData.postalCode}
                                        size={fieldSize}
                                        onChange={(e) =>
                                            handleChange("postalCode", e.target.value.toUpperCase())
                                        }
                                    />
                                    <FormHelperText>{errors.postalCode}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid xs={12} sm={6}>
                                <FormControl error={!!errors.country}>
                                    <FormLabel>Country</FormLabel>
                                    <Select
                                        value={formData.country}
                                        size={fieldSize}
                                        onChange={(_, val) => {
                                            handleChange("country", val);
                                            handleChange("state", "");
                                        }}
                                    >
                                        <Option value="Canada">Canada</Option>
                                        <Option value="USA">USA</Option>
                                    </Select>
                                    <FormHelperText>{errors.country}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={6}>
                                <FormControl error={!!errors.state}>
                                    <FormLabel>State</FormLabel>
                                    <Select
                                        value={formData.state}
                                        disabled={!formData.country}
                                        size={fieldSize}
                                        onChange={(_, val) =>
                                            handleChange("state", val)
                                        }
                                    >
                                        {(STATES[formData.country] || []).map((s) => (
                                            <Option key={s} value={s}>
                                                {s}
                                            </Option>
                                        ))}
                                    </Select>
                                    <FormHelperText>{errors.state}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Sheet variant="soft" color="primary" sx={{ p: 2, borderRadius: "md" }}>
                    <Stack direction={stackOrientation} justifyContent="space-between" alignItems="center">
                        <Button size={fieldSize} sx={{ m: 1 }} onClick={handleSubmit} disabled={!isFormValid || !isDirty}>
                            Update Profile
                        </Button>
                        <Stack direction={"row"} spacing={1}>
                            <Button color="primary" size={fieldSize} onClick={() => setshowPassword(true)}>Change password</Button>
                            {activeStatus === true || activeStatus === "true" ? (
                                <Button color="danger" size={fieldSize} onClick={() => setShowDeactivation(true)}>De-activate account</Button>
                            ) : (
                                <Button color="success" size={fieldSize} onClick={() => activateAccountForUser()}>Activate account</Button>
                            )}
                        </Stack>
                    </Stack>
                </Sheet>

            </Stack>
            <ErrorPopUp show={showErrorMsg} data={errorMsg} onHide={() => { setShowErrorMsg(false); }} />
            <SpinnerBox show={showSpinner} onHide={() => { setShowSpinner(false); }} />
            <ChangePassword show={showPassword} username={formData.userName} userId={params} defaultPassword={`${formData.firstName.charAt(0)}${formData.lastName}${new Date(formData.dob).getFullYear()}!`} isAdmin={(userType !== undefined && userType === "admin") ? true : false} handleUpdateCallback={handleUpdateCallback} onHide={() => { setshowPassword(false); }} />
            <DeactivateAccount show={showDeactivation} data={formData.userName} handleUpdateCallback={handleDeactivationCallback} onHide={() => { setShowDeactivation(false); }} />
            <SuccessPopUp show={showSuccess} data={successMsg} onHide={() => { setShowSuccess(false); }} />
        </Box >
    );
}
